/**
 * @fileoverview Progress bar component for displaying recording usage.
 * Changes color based on usage percentage: yellow -> orange -> red.
 */


/**
 * Renders a progress bar showing used vs limit.
 * @param {{ used: number, limit: number, unit?: string, decimals?: number, className?: string }} props
 * @returns {React.ReactElement}
 */
const UsageBar = ({ used, limit, unit = "min", decimals = 0, className = "" }) => {
  const percentage = limit > 0 ? Math.min((used / limit) * 100, 100) : 0;
  const displayUsed = decimals > 0 ? used.toFixed(decimals) : Math.round(used);
  const displayLimit = decimals > 0 ? limit.toFixed(decimals) : Math.round(limit);

  let barColor = "bg-[var(--accent-yellow)]"; // yellow (normal)
  if (percentage >= 100) {
    barColor = "bg-[var(--state-danger)]";
  } else if (percentage >= 80) {
    barColor = "bg-[var(--state-warning)]";
  }

  return (
    <div className={className}>
      <div className="mb-2 flex items-center justify-between">
        <span className="font-mono text-xs text-[var(--text-secondary)]">
          {displayUsed} / {displayLimit} {unit}
        </span>
        <span className="font-mono text-xs text-[var(--text-tertiary)]">{Math.round(percentage)}%</span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-[var(--studio-interactive)]">
        <div
          className={`h-full rounded-full transition-all duration-500 ${barColor}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default UsageBar;
